/** @jsxRuntime classic */
/** @jsx jsx */
import { FC } from 'react';
import { jsx } from '@emotion/react';
import { RCAddress } from '../../../types/entities/coreEntites/Address';
import { RCOrganization } from '../../../types/entities/coreEntites/Organization';
import { formatAddress } from '../../../lib/formats/address';
import { sectionCss } from '../styles';

interface IProps {
	organization: RCOrganization;
	address?: RCAddress;
}

export const TemplateHeader: FC<IProps> = (props: IProps) => {
	const { organization, address } = props;
	const addressLine = address ? formatAddress(address) : '';

	return (
		<div css={sectionCss} data-testid="application-org-masthead">
			<div className="header">
				<h1 className="title">{organization.name}</h1>
				{addressLine ? <div className="address">{addressLine}</div> : null}

				<div className="email_phone">
					<span>{organization.phoneNumber} </span>
					{organization.phoneNumber && organization.email && <span className="divider">|</span>}
					<span>{organization.email}</span>
				</div>
			</div>
		</div>
	);
};
